/**
 * Error state component shown when profile fails to load.
 */
export const ProfileErrorState = () => {
  return (
    <div>
      <p>could not find profile</p>
    </div>
  );
};
